import { BaseDto } from './base.dto';

export class UserRoleDto extends BaseDto {
  roleName: string;
}
